import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=15c6c451&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c6c451",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c6c451')) {
      api.createRecord('15c6c451', component.options)
    } else {
      api.reload('15c6c451', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=15c6c451&scoped=true&", function () {
      api.rerender('15c6c451', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8435DR4Gbw8yL/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports